
// call this function when you want non fatal errors 
// to be logged to the console asynchronously
export const throwErrorAsync = (err: any) => {
  setTimeout(() => { throw err; });
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/errorUtil.ts